import React, { useState, useEffect } from "react";
import { Checkbox } from "@mui/material";
import { setFieldValue } from "../MainContent/MainContentUtils";
import { useAppSelector } from "../../app/hooks";
import { showWarning } from "../../app/utils/validationUtils";

/* Functional component properties */
interface Props {
  classes: any;
  item: any;
  isGridElem: boolean;
  setWidth: string;
  clear: string;
  setClear: (clr: string) => void;
}

/* React Functional component */
export const CheckBoxComponent: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  item,
  isGridElem,
  setWidth,
  clear,
  setClear,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  const [val, setVal] = useState(
    item.value
      ? item.value === "true"
        ? true
        : false
      : item.colDef.value
      ? item.colDef.value === "true"
        ? true
        : false
      : false
  );

  useEffect(() => {
    if (
      val !==
      (item.value
        ? item.value === "true"
          ? true
          : false
        : item.colDef.value
        ? item.colDef.value === "true"
          ? true
          : false
        : false)
    ) {
      setVal(
        item.value
          ? item.value === "true"
            ? true
            : false
          : item.colDef.value
          ? item.colDef.value === "true"
            ? true
            : false
          : false
      );
    }
  });

  useEffect(() => {
    if (
      clear === "true" &&
      item.editable &&
      item.editable === "true" &&
      val !== false
    ) {
      setClear("false");
      setVal(false);
    } else if (clear === "true") {
      setClear("false");
    }
  });

  function handleChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    clickedRow: any
  ) {
    if (isGridElem) {
      if (item.field.substr(0, 1) !== "F") {
        window.myGlobalVar.pendingChanges.status = true; // Set pending changes

        if (
          window.myGlobalVar.pendingChanges.items.indexOf(
            `${item.field + "(" + item.id + ")"}`
          ) === -1
        )
          window.myGlobalVar.pendingChanges.items.push(
            `${item.field + "(" + item.id + ")"}`
          );
        window.myGlobalVar.pendingChanges.showWarning = false;
      }

      setFieldValue(item.field, !val, item.id ? clickedRow.id : -1);
    } else {
      if (item.name.substr(0, 1) !== "F") {
        window.myGlobalVar.pendingChanges.status = true; // Set pending changes
        if (window.myGlobalVar.pendingChanges.items.indexOf(item.name) === -1)
          window.myGlobalVar.pendingChanges.items.push(item.name);
        window.myGlobalVar.pendingChanges.showWarning = false;
      }

      setFieldValue(item.name, !val);
    }
  }

  return isGridElem ? (
    <Checkbox
      {...(showWarning(item.field, item.id) ? { color: "error" } : {})} //Modified Fields
      key={item.field + "(" + item.id + ")"}
      id={item.field + "(" + item.id + ")"}
      checked={val}
      disabled={!item.colDef.canEdit}
      className={
        item.colDef.hide === true ||
        state.mainContent.fieldList
          .find((fld) => fld.name === item.field)
          ?.rows?.find((row) => row.row === item.id)?.visible === "false"
          ? classes.hiddenField
          : "" // Hidden Fields
      }
      onChange={(event) => handleChange(event, item.row)}
    />
  ) : (
    <Checkbox
      {...(showWarning(item.name) ? { color: "error" } : {})} //Modified Fields
      key={item.name}
      id={item.name}
      checked={val}
      disabled={!item.editable}
      className={
        item.visible === true ? classes.hiddenField : "" // Hidden Fields
      }
      onChange={(event) => handleChange(event, item)}
    />
  );
};
